import Model, { attr } from '@ember-data/model';

export default Model.extend({
  // 'change-name' || 'delete'
  action: attr('string'),
  name: attr('string'),
  newName: attr('string'),
});
